export default __webpack_public_path__ + "static/media/logisticacompleta.d124c98e.png";